import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/** Возврат на предыдущий экран; без истории (прямая ссылка, пуш) — на fallback */
export function useGoBack(fallback = '/home') {
  const navigate = useNavigate();

  return useCallback(() => {
    const historyIndex =
      (window.history.state as { idx?: number } | null)?.idx ?? 0;

    if (historyIndex > 0) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  }, [navigate, fallback]);
}
